<template>
    <div class="main main-padding tabs-data-details">
        <div class="top-area">
            <!--返回-->
            <div class="main-back">
                <div class="bank-back" v-on:click="gotoBack">
                    <img src="../../../../assets/images/back.png"/>
                    <p class="click-text">返回</p>
                </div>
            </div>
            <!--时间选择器-->
            <div class="time-select-picker">
                <div class="time-select">
                    <Row :gutter="10">
                        <date-select @updateDateTime="updateDateTime" ref="dateSelect"></date-select>
                    </Row>
                </div>
            </div>
        </div>
        <!--数据信息-->
        <card>
            <!--标题及搜索框-->
            <div class="details-card-header-area">
                <!--tab切换数据-->
                <div class="details-tab-data">
                    <span>教师上传微课详情</span>
                </div>
                <!--搜索框-->
                <div class="input-data">
                    <Input
                        v-model="keyWord"
                        placeholder="支持微课名称关键字搜索"
                        icon="ios-search"
                        clearable
                        @on-enter="handleSearch"
                    >
                    <Button
                        slot="append"
                        icon="ios-search"
                        class="search-input-button"
                        @click="handleSearch"
                        type="primary"
                    ></Button>
                    </Input>
                </div>
            </div>
            <div>
                <!--微课详情-->
                <div class="table-wrapper-data">
                    <Table :columns="microColumn" :data="microClassList"></Table>
                </div>
                <!--分页,大屏重复绑定情况下不显示-->
                <div class="laypage_main">
                    <Page
                        :total="total"
                        :current="page"
                        :page-size="limit"
                        @on-change="handleCurrentChange"
                        v-show="total && pageCount>1"
                        show-total
                    />
                </div>
            </div>
        </card>
    </div>
</template>

<script>
    import {getMicroLessonUserInfo} from "../../../../service/api.js";
    import dateSelect from "../../../../components/dateSelect.vue";

    export default {
        name: "resource-details",
        data () {
            return {
                startTime: this.$route.query.selfStartDate,//主页面选择的开始时间
                endTime: this.$route.query.selfEndDate,//主页面选择的结束时间
                userId: this.$route.query.userId,//用户id
                schoolName: this.$route.query.schoolName,//学校名称
                schoolId: this.$route.query.schoolId,//学校id
                keyWord: "",
                page: 1,
                limit: 10,
                total: 0,
                pageCount: 0,
                microClassList: [],//资源集合
                microColumn: [
                    {
                        title: "序号",
                        key: "rowNum",
                        align: "center"
                    },
                    {
                        title: "微课名称",
                        key: "title",
                        align: "center"
                    },
                    {
                        title: "看懂数",
                        key: "understand",
                        align: "center"
                    },
                    {
                        title: "未看懂",
                        key: "notunderstand",
                        align: "center"
                    },
                    {
                        title: "创建时间",
                        key: "created_at",
                        align: "center"
                    },
                    {
                        title: "收藏数",
                        key: "collects",
                        align: "center"
                    },
                    {
                        title: "点击量",
                        key: "views",
                        align: "center"
                    },
                    {
                        title: "点赞数",
                        key: "likes",
                        align: "center"
                    }
                ]
            }
        },
        components: {
            dateSelect
        },
        methods: {
            /**
             *获取微课详情
             */
            async queryMicroLessonUserInfo () {
                let _this = this;
                let params = {
                    schoolId:_this.schoolId,
                    userId: _this.userId,
                    sTime:  _this.startTime + " 00:00:00",
                    eTime: _this.endTime + " 23:59:59",
                    keyWord: _this.keyWord,
                    page: _this.page,
                    limit: _this.limit
                };
                await getMicroLessonUserInfo(params)
                    .then(function (data) {
                        if (Object.keys(data).length !== 0) {
                            _this.microClassList = data.rows;
                            _this.total = data.total_rows;
                            _this.pageCount = Math.ceil(data.total_rows / _this.limit);
                        }
                    })
                    .catch(function (error) {
                        _this.$Message.error(error.message);
                    });
            },
            /**
             * 返回上一页
             */
            gotoBack () {
                this.$router.push({
                    name: "boardMain",
                    query: {
                        schoolId: this.schoolId,
                        schoolName: this.schoolName,
                        startDate: this.$route.query.selfStartDate,
                        endDate: this.$route.query.selfEndDate
                    }
                });
            },
            /**
             * 翻页
             */
            handleCurrentChange (val) {
                this.page = val;
                this.queryMicroLessonUserInfo();
            },
            /**
             * 搜索
             */
            handleSearch () {
                this.page = 1;
                this.total = 0;
                this.queryMicroLessonUserInfo();
            },
            /**
             * 更新开始时间结束时间
             */
            updateDateTime (startDate, endDate) {
                this.page = 1;
                this.startTime = startDate;
                this.endTime = endDate;
                this.queryMicroLessonUserInfo();
            }
        },
        mounted () {
            this.$nextTick(() => {
                //修改公共属性学校名称
                this.$store.commit("SET_TOPHEADERNAME", this.schoolName);
                this.queryMicroLessonUserInfo();
                //记住页面选择的开始和结束时间
                this.$refs.dateSelect.setDate(this.startTime, this.endTime);
            })
        }
    }
</script>

<style lang="scss" scoped>
    @import "../../../../style/home";
    @import "../../../../style/dataDetails";
</style>
<style lang="scss">
    .tabs-data-details {
        .ivu-input-group {
            width: 300px;
            float: right;
        }

        .ivu-card-body {
            padding: 16px;
        }

        .time-slot .ivu-col-span-lg-4 {
            display: block;
            width: 355px;
        }

        .ivu-row {
            margin-top: 0 !important;
        }

        .ivu-input-group-append .ivu-btn, .ivu-input-group-prepend .ivu-btn {
            color: #fff;
            background: #57a3f3;
        }

        .ivu-input-group .ivu-input {
            font-size: 14px;
        }

        .ivu-btn-icon-only {
            border-radius: 0 4px 4px 0;
        }

        .ivu-input-icon-clear {
            margin-right: 45px;
        }

        .ivu-table {
            font-size: 14px;
        }

        .ivu-tabs-nav {
            font-size: 14px;
        }

        .ivu-table-overflowX {
            overflow-x: hidden;
        }
    }
</style>
